module.exports = __webpack_public_path__ + "assets/images/park-04.1efb654aa0e841e6c1719f53cb7f23cb.svg";